import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Forms from './components/Forms';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import { useParams } from 'react-router-dom';

const OperacaoCadastro = ({
  isReadOnly = false,
  id: propId,
  hideHeader = false,
  disabled = false
}) => {
  const {
    id: paramId
  } = useParams();
  const id = propId || paramId;
  const isEditing = !!id;
  const isViewing = isReadOnly;
  return <Container fluid>
      {!hideHeader && <Row>
          <Col md={12}>
            <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Operações',
          path: '/pages/operacoes'
        }, {
          name: isViewing ? 'Detalhes da Operação' : isEditing ? 'Editar Operação' : 'Nova Operação'
        }]} />
          </Col>
        </Row>}
      
      <Row>
        <Col md={12}>
          <Forms isReadOnly={isReadOnly} disabled={disabled} />
        </Col>
      </Row>
    </Container>;
};

export default OperacaoCadastro;
